import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-reject-review-dialog',
  templateUrl: './reject-review-dialog.component.html',
  styleUrls: ['./reject-review-dialog.component.scss']
})
export class RejectReviewDialogComponent implements OnInit {
  form: FormGroup;
  remarks = '';
  isTemplate = false;

  constructor(public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    if (this.data.type == 'template') {
      this.isTemplate = true;
    }
    this.form = new FormGroup({
      remarks: new FormControl(this.remarks, Validators.required)
    });
  }

  reject() {
    this.dialogRef.close(this.form.controls.remarks.value);
  }

  cancel() {
    this.dialogRef.close();
  }

}
